'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.getTargetValue = getTargetValue;
exports.getDifferingProperties = getDifferingProperties;
exports.applyUpdates = applyUpdates;

var _CSSPropertyOperations = require('react-dom/lib/CSSPropertyOperations');

var _CSSPropertyOperations2 = _interopRequireDefault(_CSSPropertyOperations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getTargetValue(value) {
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
    if (value.type === 'drag') {
      return getTargetValue(value.value);
    }
    if (value.type === 'animated') {
      return value.value;
    }
  }
  return value;
}

function getDifferingProperties(a, b) {
  if (!a !== !b) {
    if (a) {
      return Object.keys(a);
    } else if (b) {
      return Object.keys(b);
    }
  }
  if (!a || !b) {
    return [];
  }

  var differingProperties = [];
  for (var key in a) {
    if (!(key in b) || a[key] !== b[key]) {
      differingProperties.push(key);
    }
  }
  for (var _key in b) {
    if (!(_key in a) || a[_key] !== b[_key]) {
      if (differingProperties.indexOf(_key) === -1) {
        differingProperties.push(_key);
      }
    }
  }
  return differingProperties;
}

function applyUpdates(layer, updates, computedStyles) {
  var transformKeyDiffers = false;
  var transformUpdateKeys = [];
  var styleUpdates = {};
  Object.keys(updates).forEach(function (property) {
    var value = updates[property];
    if (['x', 'y', 'rotate', 'scaleX', 'scaleY', 'scale'].indexOf(property) !== -1) {
      if (value !== computedStyles[property]) {
        transformKeyDiffers = true;
      }
      transformUpdateKeys.push(property);
    } else if (value !== computedStyles[property]) {
      styleUpdates[property] = value;
    }
    if (value != null) {
      computedStyles[property] = value;
    } else {
      delete computedStyles[property];
    }
  });

  if (transformKeyDiffers) {
    var transformString = 'translate3d(' + computedStyles.x + 'px,' + computedStyles.y + 'px,0)';
    if (typeof computedStyles.rotate !== 'undefined') {
      transformString += ' rotate(' + computedStyles.rotate + 'deg)';
    }
    if (typeof computedStyles.scaleX !== 'undefined') {
      transformString += ' scaleX(' + computedStyles.scaleX + ')';
    }
    if (typeof computedStyles.scaleY !== 'undefined') {
      transformString += ' scaleY(' + computedStyles.scaleY + ')';
    }
    if (typeof computedStyles.scale !== 'undefined') {
      transformString += ' scale(' + computedStyles.scale + ')';
    }
    styleUpdates.transform = transformString;
  }
  _CSSPropertyOperations2.default.setValueForStyles(layer, styleUpdates, {
    _currentElement: {},
    _debugID: 'HACK'
  });

  return transformKeyDiffers;
}


//////////////////
// WEBPACK FOOTER
// ./~/buttery/lib/AnimatedProperties.js
// module id = 164
// module chunks = 0